import { Button, Heading } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const HeaderTitle = styled(Heading)`
    margin: ${getPurpurSpacing('400')} ${getPurpurSpacing('250')};

    ${purpurMedia('md')`
        margin: ${getPurpurSpacing('400')} 1.875rem;
    `};
`;

export const FooterButton = styled(Button)`
    display: block;
    width: max-content;

    margin: ${getPurpurSpacing('250')};

    ${purpurMedia('md')`
        margin: ${getPurpurSpacing('400')} 1.875rem;
    `};
`;
